import React from 'react';

interface DateColumnFormatterProps {
  date: number;
}

const options: Intl.DateTimeFormatOptions = {
  timeZoneName: 'short',
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
};

/**
 * This method is responsible to compare between 2 date objects.
 * @param filterLocalDateAtMidnight the date in the filter
 * @param cellValue : the date format in the cell.
 * @returns -1, 1, 0
 */
export function dateComparator(
  filterLocalDateAtMidnight: Date,
  cellValue: string,
) {
  if (cellValue == null) {
    return 0;
  }
  const date = new Date(cellValue);
  const cellDate = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
  );
  if (cellDate < filterLocalDateAtMidnight) {
    return -1;
  } else if (cellDate > filterLocalDateAtMidnight) {
    return 1;
  }
  return 0;
}

export const DateColumnFormatter = ({ date }: DateColumnFormatterProps) => {
  const formattedDate = new Date(date).toLocaleDateString(undefined, options);
  //op: Mar 15, 2023, 01:34 PM PST
  const dateInParts = formattedDate.split(',');
  const [month, year, time] = dateInParts;
  return (
    <div>
      {month},{year}
      <span style={{ fontSize: '0.6rem' }}>{time}</span>
    </div>
  );
};
